import { AODA } from "@core/utilities/aoda";
import {
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewEncapsulation,
} from "@angular/core";
import { BaseComponent } from "@shared/components/base.component";
import { FormGroup } from "@angular/forms";
import { DatabaseType } from "@shared/models/common/database-type.model";

@Component({
  selector: "app-database-filter",
  templateUrl: "./database-filter.component.html",
  styleUrls: ["./database-filter.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DatabaseFilter extends BaseComponent implements OnInit, OnDestroy {
  
  @Input() f: FormGroup;
  @Input() clearFilter: boolean;
  @Output() databaseIsSelected = new EventEmitter<boolean>();
  dbIsSelected: boolean = true;
  displayDatabaseFilter: boolean = false;

  constructor(
    private injector: Injector,
    private el: ElementRef,
    private r2: Renderer2,
  ) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
  }

  ngOnChanges() {
    if(this.clearFilter) {
      this.selectAllDatabases(true);
      this.clearFilter = false;
    }
  }

  //Filter Functions
  onDisplayDatabaseFilter() {
    this.displayDatabaseFilter = !this.displayDatabaseFilter;
  }

  onDatabaseTypeChange(database: any) {
    var db = this.databases.value[database.id];
    if (db.id === DatabaseType.allDatabases) {
      this.selectAllDatabases(!db.checked);
    } else {
      db.checked = db.checked ? false : true;
    }
    this.databases.setValue(this.databases.value);
    this.countSelectedDatabases();
  }

  selectAllDatabases(isChecked: any) {
    this.databases.value.forEach((item) => {
      item.checked = isChecked;
    });
    this.databases.setValue(this.databases.value);
  }

  unselectAllDatabases() {
    var uncheck = false;
    this.databases.value.forEach((item) => {
      if(item.id != DatabaseType.allDatabases && item.checked === false) {
        uncheck = true;
      }
    });

    this.databases.value[DatabaseType.allDatabases].checked = uncheck ? false : true;
    this.databases.setValue(this.databases.value);
  }

  countSelectedDatabases() {
    var tempCounter = 0;
    this.databases.value.forEach((item) => {
      if (item.checked) {
        tempCounter += 1;
      }
    });
    
    this.dbIsSelected = tempCounter < 1 ? false : true;

    if(tempCounter < 1) {
      this.databaseIsSelected.emit(false);
    } else {
      this.databaseIsSelected.emit(true);
    }

    this.unselectAllDatabases();
  }

  get databases() {
    return this.f.get("databases");
  }

}
